/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EpisodeAccessModel } from './EpisodeAccessModel';
import {
    EpisodeAccessModelFromJSON,
    EpisodeAccessModelFromJSONTyped,
    EpisodeAccessModelToJSON,
} from './EpisodeAccessModel';
import type { GetRecentlyCompletedEpisodeInSeries200Response } from './GetRecentlyCompletedEpisodeInSeries200Response';
import {
    GetRecentlyCompletedEpisodeInSeries200ResponseFromJSON,
    GetRecentlyCompletedEpisodeInSeries200ResponseFromJSONTyped,
    GetRecentlyCompletedEpisodeInSeries200ResponseToJSON,
} from './GetRecentlyCompletedEpisodeInSeries200Response';

/**
 * ユーザーに対する作品の閲覧権限を表します。
 * 
 * 有料作品の購入状況、各話に対する閲覧の可否状況を含みます。
 * @export
 * @interface SeriesAccessModel
 */
export interface SeriesAccessModel {
    /**
     * 作品ID
     * @type {string}
     * @memberof SeriesAccessModel
     */
    seriesId: string;
    /**
     * 各話の閲覧権限
     * @type {Array<EpisodeAccessModel>}
     * @memberof SeriesAccessModel
     */
    episodeAccesses?: Array<EpisodeAccessModel>;
    /**
     * ユーザが読了済みの情報
     * @type {Array<GetRecentlyCompletedEpisodeInSeries200Response>}
     * @memberof SeriesAccessModel
     */
    episodeReadCompleteInfo?: Array<GetRecentlyCompletedEpisodeInSeries200Response>;
}

/**
 * Check if a given object implements the SeriesAccessModel interface.
 */
export function instanceOfSeriesAccessModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "seriesId" in value;

    return isInstance;
}

export function SeriesAccessModelFromJSON(json: any): SeriesAccessModel {
    return SeriesAccessModelFromJSONTyped(json, false);
}

export function SeriesAccessModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesAccessModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'seriesId': json['seriesId'],
        'episodeAccesses': !exists(json, 'episodeAccesses') ? undefined : ((json['episodeAccesses'] as Array<any>).map(EpisodeAccessModelFromJSON)),
        'episodeReadCompleteInfo': !exists(json, 'episodeReadCompleteInfo') ? undefined : ((json['episodeReadCompleteInfo'] as Array<any>).map(GetRecentlyCompletedEpisodeInSeries200ResponseFromJSON)),
    };
}

export function SeriesAccessModelToJSON(value?: SeriesAccessModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'seriesId': value.seriesId,
        'episodeAccesses': value.episodeAccesses === undefined ? undefined : ((value.episodeAccesses as Array<any>).map(EpisodeAccessModelToJSON)),
        'episodeReadCompleteInfo': value.episodeReadCompleteInfo === undefined ? undefined : ((value.episodeReadCompleteInfo as Array<any>).map(GetRecentlyCompletedEpisodeInSeries200ResponseToJSON)),
    };
}

